import React from 'react';
import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';

import { Container, Segment, Image } from 'semantic-ui-react';
import { Message } from 'semantic-ui-react';
import logo from "../../images/logo/logo-full-black.png";
import LoadingComponent from "../common/LoadingComponent";

//import {login} from "../../services/auth0.js";

class SSOPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        };
    }

    componentWillMount() {
        const companyId = this.props.match.params.id;
        dispatch.app.initiateSSOLogin(companyId);
        this.setState({ loading: false });
    }

    render() {
        let loadingState = this.state.loading;
        const ssoConfigError = this.props.ssoConfigError;

        let errorComponent = null;
        if (ssoConfigError) {
            loadingState = false;
            errorComponent =  <Message error>
                    <Message.Header>Incorrect SSO Configuration</Message.Header>
                    <p>
                        The path "{this.props.match.params.id}" is not cofigured for Single Sign On. Please contact administrator!
                    </p>
            </Message>
        }


        return (
            <div>
                <Segment clearing>
                    <div style={{ "float": "left" }} >
                        <Image src={logo} size='small' centered={true} />
                    </div>
                </Segment>
                <Container>
                    <LoadingComponent active={loadingState} message="Single Sign On" />    
                    { errorComponent }
                </Container>
    

            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        ssoConfig: state.app.ssoConfig,
        ssoConfigError: state.app.ssoConfigError,
    };
}

const connectedSSOPage = connect(mapStateToProps)(SSOPage);

export { connectedSSOPage as SSOPage }; 